import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem("lestari_token");
    if (!token) {
      setUser(null);
      setTenant(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setTenant(data.tenant || null);
    } catch (e) {
      localStorage.removeItem("lestari_token");
      localStorage.removeItem("lestari_user");
      setUser(null);
      setTenant(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const device_token = localStorage.getItem("lestari_device_token") || undefined;
    const { data } = await api.post("/auth/login", { email, password, device_token });
    if (data.mfa_required) return data;
    localStorage.setItem("lestari_token", data.access_token);
    localStorage.setItem("lestari_user", JSON.stringify(data.user));
    await refresh();
    return data.user;
  };

  const verifyMfa = async (mfaToken, code, rememberDevice = false) => {
    const { data } = await api.post("/auth/mfa/verify", {
      mfa_token: mfaToken, code, remember_device: rememberDevice,
    });
    if (data.device_token) localStorage.setItem("lestari_device_token", data.device_token);
    localStorage.setItem("lestari_token", data.access_token);
    localStorage.setItem("lestari_user", JSON.stringify(data.user));
    await refresh();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("lestari_token", data.access_token);
    localStorage.setItem("lestari_user", JSON.stringify(data.user));
    await refresh();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("lestari_token");
    localStorage.removeItem("lestari_user");
    setUser(null);
    setTenant(null);
    window.location.href = "/welcome";
  };

  return (
    <AuthContext.Provider value={{ user, tenant, loading, login, verifyMfa, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
